import React from 'react';
import { Link } from 'react-router-dom';
import * as LucideIcons from 'lucide-react';
import { CATEGORIES } from '@/mock/products';
import { useCategories } from '@/store/dataStore';
import { useLabels } from '@/services/labelsService';
import HScroll from '@/components/HScroll';

export default function CategoryStrip() {
  const { label: L } = useLabels();
  const { categories } = useCategories();
  const CATS = categories && categories.length ? categories : CATEGORIES;
  return (
    <section className="max-w-7xl mx-auto px-4 py-8">
      <div className="flex items-end justify-between mb-4">
        <h2 className="text-2xl md:text-3xl font-extrabold text-[#1B2A4A]">Explorar Categorías</h2>
        <Link to="/catalogo" className="text-sm font-semibold text-[#1B2A4A] hover:text-yellow-600 underline underline-offset-4">Ver todos</Link>
      </div>
      <HScroll testid="category-strip">
        {CATS.map((c) => {
          const Icon = LucideIcons[c.icon] || LucideIcons.Package;
          return (
            <Link
              key={c.id}
              to={`/catalogo?cat=${c.id}`}
              data-testid={`category-chip-${c.id}`}
              className="group snap-start shrink-0 w-[96px] md:w-[112px] flex flex-col items-center gap-2 p-3 rounded-xl bg-white border border-slate-200 hover:border-yellow-400 hover:shadow-md transition"
            >
              <div className="w-14 h-14 rounded-full bg-[#F8D13F] flex items-center justify-center text-[#1B2A4A] group-hover:scale-110 transition-transform">
                <Icon size={26} strokeWidth={2.2} />
              </div>
              <span className="text-xs md:text-[13px] font-semibold text-[#1B2A4A] text-center leading-tight">{L(`category.${c.id}`, c.name)}</span>
            </Link>
          );
        })}
      </HScroll>
    </section>
  );
}
